import CommentIcon from "@mui/icons-material/Comment";
import { Tooltip, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.swaBlue,
    fontSize: "30px",
  },
  toolTip: {
    maxWidth: "200px",
    fontSize: "12px",
  },
}));

const StarsCommentIcon = (props) => {
  const classes = useStyles();

  return props.toolTipMessage ? (
    <Tooltip
      title={
        <React.Fragment>
          <Typography color="inherit" fontSize="14px" fontWeight="bold">
            {props.toolTipHeader}
          </Typography>
          {props.toolTipMessage}
        </React.Fragment>
      }
      arrow
      placement={props.tooltipPlacement || "right"}
      classes={{ tooltip: classes.toolTip }}
    >
      <CommentIcon className={classes.icon} />
    </Tooltip>
  ) : (
    <CommentIcon className={classes.icon} />
  );
};

StarsCommentIcon.propTypes = {
  toolTipHeader: PropTypes.string,
  toolTipMessage: PropTypes.string,
  tooltipPlacement: PropTypes.string,
};

export default StarsCommentIcon;
